module.exports = __webpack_public_path__ + "fonts/AdelleSansSAGE.21a8eda8.eot";